import React, { Component } from 'react';
import { findDOMNode } from 'react-dom'
import ReactSelect from 'react-select';
import axios from 'axios';
import { connect } from 'react-redux';
import {reduxForm} from 'redux-form';
import _ from 'lodash';
import moment from 'moment';
import { Portal } from 'react-overlays';
import TetherComponent from 'react-tether';
import Dimensions from 'react-dimensions';

import 'react-select/dist/react-select.css';

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Highlighter from 'react-highlight-words';

const DateCalendarContainer = ({children}) => {
	const el = document.getElementById('date-body-cont')

	return (
		<Portal container={el}>
			{children}
		</Portal>
	)
}

const DimensionOptions = {
	className: 'dimension-custom-class'
};

class TetheredSelectWrap extends ReactSelect {
	constructor(props) {
		super(props);

		this.renderOuter = this._renderOuter;
	}

	componentDidMount() {
		super.componentDidMount.call(this);
	}

	_renderOuter() {
		const {
			containerWidth
		} = this.props;
		const menu = super.renderOuter.apply(this, arguments);

		// Don't return an updated menu render if we don't have one
		if (!menu) {
			return;
		}
		return (
			<TetherComponent
				renderElementTo="body"
				ref="tethered-component"
				attachment="top left"
				targetAttachment="top left"
				className="tether-select-height"
				constraints={[{
				  to: 'window',
				  attachment: 'together',
				  pin: ['top']
				}]}
			>
			{/* Apply position:static to our menu so that it's parent will get the correct dimensions and we can tether the parent */}
			<div></div>
				{React.cloneElement(menu, {style: {position: 'static', width: containerWidth}})}
			</TetherComponent>
		);

	}
}

class TetheredSelectAsync extends React.Component {
	render() {
		return (
			<TetheredSelectWrap.Async {...this.props}>
				{(asyncProps) => (
					<TetheredSelectWrap
						{...this.props}
						{...asyncProps} />
				)}
			</TetheredSelectWrap.Async>
		);
	}
}

class TetheredSelectNormal extends React.Component {
	render() {
		return (
			<TetheredSelectWrap
				{...this.props} />
		);
	}
}

class TetheredSelectAsyncCreatable extends React.Component {
	render() {
		return (
			<TetheredSelectWrap.Async {...this.props}>
				{(asyncProps) => (
					<TetheredSelectWrap.Creatable {...this.props}>
						{(creatableProps) => (
							<TetheredSelectWrap
								{...this.props}
								{...asyncProps}
								{...creatableProps}
								onInputChange={(input) => {
									creatableProps.onInputChange(input);
									return asyncProps.onInputChange(input);
								}} />
						)}
					</TetheredSelectWrap.Creatable>
				)}
			</TetheredSelectWrap.Async>
		);
	}
}

const isTouchEnabled = ('ontouchstart' in window || 'onmsgesturechange' in window);

const ReactSelectAsync = isTouchEnabled ? ReactSelect.Async : Dimensions(DimensionOptions)(TetheredSelectAsync);
const ReactSelectNormal = isTouchEnabled ? ReactSelect : Dimensions(DimensionOptions)(TetheredSelectNormal);
const ReactSelectAsyncCreatable = isTouchEnabled ? ReactSelect.AsyncCreatable : Dimensions(DimensionOptions)(TetheredSelectAsyncCreatable);



export class DateElement extends Component {
	constructor(props) {
		super(props);

		this.state = {
			value: this.props.value ? moment(this.props.value).format('DD-MMM-YYYY') : ''
		};

		this.onBlur = this.onBlur.bind(this);
		this.handleChangeRaw = this.handleChangeRaw.bind(this);
		this.clickOutside = this.clickOutside.bind(this);
	}

	componentWillReceiveProps(nextprops) {
		this.setState({
			value: nextprops.value ? moment(nextprops.value).format('DD-MMM-YYYY') : ''
		});
	}

	onBlur(evt) {
		let value = moment(evt.target.value, "DD-MMM-YYYY");
		if(value._d == 'Invalid Date')
			this.props.onChange(null);
		this.setState({
			value: this.props.value ? moment(this.props.value).format('DD-MMM-YYYY') : ''
		});
	}

	handleChangeRaw(value) {
		this.setState({
			value
		});
	}

	clickOutside() {
		this.refs.picker.cancelFocusInput();
		this.refs.picker.setOpen(false);
	}

	render() {
		return (
			<DatePicker
				isClearable={this.props.disabled ? false : true}
				ref="picker"
				className={this.props.className}
				value={this.state.value}
				selected={this.props.value ? moment(this.props.value) : null}
				onChange={(value) => this.props.onChange((value == null || value == '') ? null : value._d)}
				onFocus={this.props.onFocus}
				onBlur={this.onBlur}
				required={this.props.required}
				disabled={this.props.disabled}
				minDate = {this.props.min}
				maxDate={this.props.max}
				dateFormat="DD-MMM-YYYY"
				todayButton={"Today"}
				showMonthDropdown
				showYearDropdown
				disabledKeyboardNavigation
				popperContainer={DateCalendarContainer}
				dropdownMode="select"
				onChangeRaw={(event) =>this.handleChangeRaw(event.target.value)}
				placeholderText={this.props.placeholder}
				onClickOutside={this.clickOutside}
				autoComplete="off"
				autoFocus={this.props.autoFocus ? this.props.autoFocus : false} />
		);
	}
}

export class DateRangeField extends Component {
	constructor(props) {
		super(props);
		this.state = {
			//year : moment().format('YYYY'),
			//quarter : `Q${moment().format('Q')}`,
			//month : moment().format('MMM'),
			showyear : this.props.format && this.props.format.indexOf('Y') >= 0 ? true : false,
			showquarter : this.props.format && this.props.format.indexOf('Q') >= 0 ? true : false,
			showmonth : this.props.format && this.props.format.indexOf('M') >= 0 ? true : false,
			count : this.props.format ? this.props.format.length : 1
		};
		
		this.generateFromToDate = this.generateFromToDate.bind(this);
		this.yearOnChange = this.yearOnChange.bind(this);
	}

	componentDidMount(){
		//this.generateFromToDate();
		this.yearOnChange();
	}

	yearOnChange(value){
		let quarter = ['All','Q1','Q2','Q3','Q4'];
		let quarterObj = {
			'1' : {
				'Mumbai New' : {
					'15/Jan/2024 to 14/Jan/2025' : ['Q1 - 15/Jan/2024 to 14/Apr/2024','Q2 - 15/Apr/2024 to 14/Jul/2024','Q3 - 15/Jul/2024 to 14/Oct/2024','Q4 - 15/Oct/2024 to 14/Jan/2025'],
					'15/Jan/2025 to 14/Jan/2026' : ['Q1 - 15/Jan/2025 to 14/Apr/2025','Q2 - 15/Apr/2025 to 14/Jul/2025','Q3 - 15/Jul/2025 to 14/Oct/2025','Q4 - 15/Oct/2025 to 14/Jan/2026']
				}
			},
			'3' : {
				'18/Nov/2019 to 17/Nov/2020' : ['Q1 - 18/Nov/2019 to 17/Feb/2020','Q2 - 18/Feb/2020 to 17/May/2020','Q3 - 18/May/2020 to 17/Aug/2020','Q4 - 18/Aug/2020 to 17/Nov/2020'],
				'18/Nov/2020 to 17/Nov/2021' : ['Q1 - 18/Nov/2020 to 17/Feb/2021','Q2 - 18/Feb/2021 to 17/May/2021','Q3 - 18/May/2021 to 17/Aug/2021','Q4 - 18/Aug/2021 to 17/Nov/2021'],
				'18/Nov/2021 to 17/Nov/2022' : ['Q1 - 18/Nov/2021 to 17/Feb/2022','Q2 - 18/Feb/2022 to 17/May/2022','Q3 - 18/May/2022 to 17/Aug/2022','Q4 - 18/Aug/2022 to 17/Nov/2022'],
				'18/Nov/2022 to 17/Nov/2023' : ['Q1 - 18/Nov/2022 to 17/Feb/2023','Q2 - 18/Feb/2023 to 17/May/2023','Q3 - 18/May/2023 to 17/Aug/2023','Q4 - 18/Aug/2023 to 17/Nov/2023'],
				'18/Nov/2023 to 17/Nov/2024' : ['Q1 - 18/Nov/2023 to 17/Feb/2024','Q2 - 18/Feb/2024 to 17/May/2024','Q3 - 18/May/2024 to 17/Aug/2024','Q4 - 18/Aug/2024 to 17/Nov/2024'],
				'18/Nov/2024 to 17/Nov/2025' : ['Q1 - 18/Nov/2024 to 17/Feb/2025','Q2 - 18/Feb/2025 to 17/May/2025','Q3 - 18/May/2025 to 17/Aug/2025','Q4 - 18/Aug/2025 to 17/Nov/2025']
			},
			'8': {
				'01/Apr/2025 to 31/Mar/2026': ['Q1 - 01/Apr/2025 to 30/Jun/2025','Q2 - 01/Jul/2025 to 30/Sep/2025','Q3 - 01/Oct/2025 to 31/Dec/2025','Q4 - 01/Jan/2026 to 31/Mar/2026']
			},
			'9': {
				'15/May/2025 to 14/May/2026': ['Q1 - 15/May/2025 to 14/Aug/2025','Q2 - 15/Aug/2025 to 14/Nov/2025','Q3 - 15/Nov/2025 to 14/Feb/2025','Q4 - 15/Feb/2026 to 14/May/2026']
			}
		};
		if(this.props.app.companyid == 3){
			quarter = quarterObj[3][value];
		}else if (this.props.app.companyid == 1 && ['Mumbai New'].includes(this.props.app.branch)){
			quarter = quarterObj[this.props.app.companyid][this.props.app.branch][value];
		}else if (this.props.app.companyid == 8) quarter = quarterObj[this.props.app.companyid][value];
		else if (this.props.app.companyid == 9) quarter = quarterObj[this.props.app.companyid][value];
		this.setState({
			year : value,
			quarterOption : quarter
		},() => {
			this.generateFromToDate();
		});
	}


	generateFromToDate(){
		let {year,quarter,month} = this.state;
		let fromdate = null,todate=null;

		if(this.props.app.companyid == 9 || this.props.app.companyid == 8 || this.props.app.companyid == 3 || (this.props.app.companyid == 1 && this.props.app.branch == 'Mumbai New')){
			fromdate = quarter ? quarter.split(' - ')[1].split(' to ')[0] : null;
			todate = quarter ? quarter.split(' - ')[1].split(' to ')[1] : null;
		}else{
			let monthArray = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
			let quarterArray = ['Q1','Q2','Q3','Q4'];
			quarter = (!this.state.showquarter || quarter == 'All') ? null : quarter;
			month = (!this.state.showmonth || month == 'All') ? null : month;
			if(year && !quarter && !month){
				fromdate = moment([year]).toString();
				todate =  moment(fromdate).endOf('year').toString();
			}else if(year && quarter && !month){
				fromdate = moment([year]).quarter(quarterArray.indexOf(quarter)+1).toString();
				todate =  moment(fromdate).endOf('quarter').toString();
			}else if (year && !quarter && month){
				fromdate = moment([year, monthArray.indexOf(month)]).toString();
				todate =  moment(fromdate).endOf('month').toString();
			}else if(year && quarter && month){
				fromdate = moment([year, monthArray.indexOf(month)]).toString();
				todate =  moment(fromdate).endOf('month').toString();
			}
		}

		let value = {
			fromdate : fromdate,
			todate : todate
		};

		this.props.onChange(value);
	}

	render() {
		let {year,quarter,month,count,showyear,showquarter,showmonth,quarterOption} = this.state;

		let cwidth = Math.floor(100/count);

		let yearoption = [];

		if(this.props.app.companyid == 1 && ['Mumbai', 'Mumbai New'].includes(this.props.app.branch)) yearoption = ['2020','2021','2022', '2023', '2024'];
		if(this.props.app.companyid == 1 && this.props.app.branch == 'Jharkhand') yearoption = ['2017','2018','2019','2020','2021','2022', '2023', '2024'];
		if(this.props.app.companyid == 1 && this.props.app.branch == 'Tata') yearoption = ['2019','2020','2021','2022', '2023', '2024'];
		if(this.props.app.companyid == 1 && this.props.app.branch == 'Arunachal Pradesh') yearoption = ['2017','2018','2019','2020','2021','2022', '2023','2024'];
		if(this.props.app.companyid == 1 && this.props.app.branch == 'Tripura') yearoption = ['2016','2017','2018','2019','2020','2021','2022','2023', '2024'];
		if(this.props.app.companyid == 1 && this.props.app.branch == 'Tripura New') yearoption = ['2022','2023', '2024'];
		if(this.props.app.companyid == 1 && this.props.app.branch == 'Mizoram') yearoption = ['2016','2017','2018','2019','2020','2021','2022', '2023', '2024'];
		if(this.props.app.companyid == 1 && this.props.app.branch == 'Nagaland') yearoption = ['2022','2023', '2024'];
		if(this.props.app.companyid == 3) yearoption = ['18/Nov/2019 to 17/Nov/2020','18/Nov/2020 to 17/Nov/2021','18/Nov/2021 to 17/Nov/2022','18/Nov/2022 to 17/Nov/2023', '18/Nov/2023 to 17/Nov/2024', '18/Nov/2024 to 17/Nov/2025'];
		if(this.props.app.companyid == 4) yearoption = ['2018','2019','2020','2021','2022','2023', '2024'];
		if(this.props.app.companyid == 1 && this.props.app.branch == 'Goa') yearoption = ['2023', '2024'];
		if(this.props.app.companyid == 1 && this.props.app.branch == 'BMC BLR') yearoption = ['2024'];
		if(this.props.app.companyid == 1 && ['Mumbai New'].includes(this.props.app.branch)) yearoption = ['15/Jan/2024 to 14/Jan/2025', '15/Jan/2025 to 14/Jan/2026'];
		if(this.props.app.companyid == 7) yearoption = ['2025'];
		if(this.props.app.companyid == 8) yearoption = ['01/Apr/2025 to 31/Mar/2026'];
		if(this.props.app.companyid == 9) yearoption = ['15/May/2025 to 14/May/2026'];

		return (
			<div className="row" style={{width : '100%'}}>
				{
					(showyear) ?
						<div style={{width:`${cwidth}%`,paddingLeft:"15px",paddingRight:"15px"}}>
							<LocalSelect placeholder={'Select Year'} className={`${(!this.state.year) ? 'errorinput' : ''}`} name={'year'} options={yearoption} value={year} multiselect={false} required={true} onChange={(value)=>{this.yearOnChange(value)}} />
						</div>
					 : null
				}
				{
					(showquarter) ? 
						<div style={{width:`${cwidth}%`,paddingLeft:"15px",paddingRight:"15px"}}>
							<LocalSelect placeholder={'Select Quarter'} className={`${(!this.state.quarter) ? 'errorinput' : ''}`} name={'quarter'} options={quarterOption} value={quarter} multiselect={false} required={true} onChange={(value)=>{this.setState({quarter : value},() => {this.generateFromToDate();});}} />
						</div>
					 : null
				}
				{
					(showmonth) ? 
						<div style={{width:`${cwidth}%`,paddingLeft:"15px"}}>
							<LocalSelect placeholder={'Select Month'} className={`${(!this.state.month) ? 'errorinput' : ''}`} name={'month'} options={['All','Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']} value={month} multiselect={false} required={true} onChange={(value)=>{this.setState({month : value},() => {this.generateFromToDate();});}} />
						</div> 
					: null
				}	
			</div>
		);
	}
}

export class LocalSelect extends Component {
	constructor(props) {
		super(props);

		this.onChange = this.onChange.bind(this);
	}

	onChange(value) {
		if(this.props.multiselect) {
			this.props.onChange(value ? value.map((l) => l.value) : null);
		} else {
			this.props.onChange(value ? value.value : null, value ? (value.valueObj ? value.valueObj : {}) : {});
		}
	}

	render() {
		let optionArray = [];
		let label = this.props.label ? this.props.label : 'name';
		let valuename = this.props.valuename ? this.props.valuename : 'id';
		if(this.props.options && this.props.options.length > 0 && typeof(this.props.options[0]) == 'string') {
			this.props.options.map(function(a) {
				optionArray.push({
					label : a,
					value : a
				});
			});
		} else {
			if(label && valuename && this.props.options) {
				optionArray = JSON.parse(JSON.stringify(this.props.options));
				optionArray.map(function(a) {
					a.valueObj = {...a};
					a.label = a[label];
					a.value = a[valuename];
					a.title = '';
				});
			}
		}
		return (
			<ReactSelectNormal
				autoBlur={this.props.multiselect ? false : true}
				className={`${this.props.className} ${this.props.disabled ? 'ndtclass' : ''}`}
				clearable={this.props.clearable == false ? false : true}
				options={optionArray}
				name={this.props.name}
				value={this.props.value}
				multi={this.props.multiselect}
				onChange={this.onChange}
				placeholder={this.props.placeholder}
				disabled={this.props.disabled}
				required={this.props.required}
				clearable={this.props.required ? false : true}
				autoFocus={this.props.autoFocus} />
		);
	}
}


export const SelectAsync = connect((state) =>{
	return {app: state.app}
}) (class extends Component {
	constructor(props) {
		super(props);
		
		this.state = {
			optionArray : [],
			labelKey: this.props.label ? this.props.label : `name`,
			valueKey: this.props.valuename ? this.props.valuename : `id`,
			searchInputValue: ""
		};
		this.getOptions = this.getOptions.bind(this);
		this.onChange = this.onChange.bind(this);
		this.optionRenderer = this.optionRenderer.bind(this);
		this.onInputChange = this.onInputChange.bind(this);
	}

	componentWillMount() {
		this.getOptions();
	}

	componentWillReceiveProps(nextProps) {
		/*if(this.props.resource != nextProps.resource || this.props.filter != nextProps.filter  || this.props.refresh != nextProps.refresh) {
			this.setState({
				optionArray : [],
				labelKey: nextProps.label ? nextProps.label : `name`,
				valueKey: nextProps.valuename ? nextProps.valuename : `id`
			}, function() {
				this.getOptions();
			});
		}*/
	}



	getOptions() {
		if(this.props.resource == "companymaster") {
			this.setState({
				optionArray : [this.props.app.selectedCompanyDetails]
			});
		} else {
			

			let url = `/api/${this.props.resource}`;
			
			axios.get(url).then((response) => {
				if(response.data.message == 'success') {
					response.data.main.sort((a, b) => {
						return (a[this.state.labelKey].toLowerCase() > b[this.state.labelKey].toLowerCase() ? 1 : (a[this.state.labelKey].toLowerCase() < b[this.state.labelKey].toLowerCase() ? -1 : 0));
					});
					this.setState({
						optionArray: [...response.data.main]
					});
					
				} else
					this.setState({optionArray: []});
			});
		}
	}

	onChange(value) {
		if(value) {
			this.props.onChange(value[this.state.valueKey], value);
		} else {
			this.props.onChange(null, {});
		}
	}

	onInputChange(value) {
		this.setState({
			searchInputValue : value
		});
	}

	optionRenderer (option) {
		return (
			<Highlighter highlightClassName="select-text-highlighter" autoEscape={true} searchWords={[this.state.searchInputValue]} textToHighlight={option[this.state.labelKey]}/>
		);
	}

	render() {
		return (
			<ReactSelectNormal
				autoBlur={true}
				valueKey={this.state.valueKey}
				labelKey={this.state.labelKey}
				options={this.state.optionArray}
				optionRenderer={this.optionRenderer}
				onInputChange = {this.onInputChange}
				name={this.props.name}
				value={this.props.value}
				onChange={this.onChange}
				placeholder={this.props.placeholder}
				filterOptions={this.filterOptions}
				className={`${this.props.className} ${this.props.disabled ? 'ndtclass' : ''}`}
				required={this.props.required}
				disabled={this.props.disabled}
				clearable={this.props.required ? false : true}
				autoFocus={this.props.autoFocus} />
		);
	}
});

export const AutoSelect = connect((state) =>{
	return {app: state.app}
}) (class extends Component {
	constructor(props) {
		super(props);

		this.state = {
			optionArray : [],
			labelKey: this.props.label ? this.props.label : `name`,
			displayLabelKey : this.props.displaylabel ? this.props.displaylabel : (this.props.label ? this.props.label : `name`),
			valueKey: this.props.valuename ? this.props.valuename : `id`,
			parentJson: this.props.resourceName,
			searchInputValue : ''
		};
		if(this.props.value) this.getStateValue(this.props.value);
		this.getOptions = this.getOptions.bind(this);
		this.onChange = this.onChange.bind(this);
		this.valueRenderer = this.valueRenderer.bind(this);
		//this.getCustomField = this.getCustomField.bind(this);
		this.renderSelect = this.renderSelect.bind(this);
		//this.editItem = this.editItem.bind(this);
		this.optionRenderer = this.optionRenderer.bind(this);
		this.onInputChange = this.onInputChange.bind(this);
	}

	componentWillReceiveProps(nextProps) {
		if(nextProps.value) {
			if(!this.state.value || nextProps.value != this.state.value[this.state.valueKey]) this.getStateValue(nextProps.value);
		} else {
			if(this.state.value) this.resetStateValue();
		}
	}

	getOptions(input, callback) {
		if(input == '' || input == undefined || input == null || input == '__' )
			return callback(null, {
				options: []
			});

		let filterField = `${this.props.filter != "" && this.props.filter != undefined && this.props.filter != null ? this.props.filter : ''}`;

		filterField += `${filterField!="" ? ' and ' : ''} ${this.state.parentJson}.${this.state.labelKey}`;

		let filterString = `${filterField} ILIKE '%${input.replace(/ /g, '%%').replace(/'/g, "''")}%'`;

		let sortstring = `case when ${this.state.parentJson}.${this.state.labelKey} ILIKE '${input.replace(/'/g, "''")}' then 1 when ${this.state.parentJson}.${this.state.labelKey} ILIKE '${input.replace(/'/g, "''")}%' then 2 when ${this.state.parentJson}.${this.state.labelKey} ILIKE '%${input.replace(/'/g, "''")}%' then 3 else 4 end`;

		filterString = encodeURIComponent(filterString);
		sortstring = encodeURIComponent(sortstring);

		let url = `/api/${this.props.resource}?field=${this.props.fields}&sortstring=${sortstring}&filtercondition=${filterString}`;

		axios.get(url).then((response) => {
			if(response.data.message == 'success') {
				callback(null, {
					options: [...response.data.main]
				});
			} else {
				callback(null, {
					options: []
				});
			}
		});
	}

	onChange(value) {
		if(value) {
			this.props.onChange(value[this.state.valueKey], value);
			this.setState({
				value: value
			});
		} else {
			this.props.onChange(null, {});
			this.setState({
				value: null
			});
		}
	}

	valueRenderer(value) {
		if(this.props.disabled)
			return value ? value[this.state.displayLabelKey] : null;
		return '';
	}

	getStateValue(selectedValue) {
		
		let filterString = `${this.state.parentJson}.${this.state.valueKey}=${selectedValue.toString().length > 10 ? `'${selectedValue}'` : selectedValue}`;
		let url = `/api/${this.props.resource}?field=${this.props.fields}&skip=0&pagelength=10&filtercondition=${filterString}`;

		axios.get(url).then(function(response) {
			if(response.data.message == 'success') {
				if(response.data.main.length > 0) {
					if(selectedValue == this.props.value) {
						let value = {};
						value[this.state.valueKey] = this.props.value;
						value[this.state.labelKey] = response.data.main[0][this.state.labelKey];
						value[this.state.displayLabelKey] = response.data.main[0][this.state.displayLabelKey];

						this.setState({value});
					}
				}
			}
		}.bind(this));
	}

	resetStateValue() {
		setTimeout(function() {
			this.setState({value : null});
		}.bind(this), 0);
	}

	inputRenderer(args) {
		return <InputRenderer {...args} custvalueObj={{value: this.state.value, displayLabelKey:this.state.displayLabelKey, disabled: this.props.disabled}} />
	}

	onInputChange(value) {
		this.setState({
			searchInputValue : value
		});
	}

	optionRenderer(option) {
		return(
			<Highlighter highlightClassName="select-text-highlighter" autoEscape={true} searchWords={[this.state.searchInputValue]} textToHighlight={option[this.state.labelKey]} />
		);
	}

	renderSelect() {
		return (
			<ReactSelectAsync
				autoBlur={true}
				valueKey={this.state.valueKey}
				labelKey={this.state.labelKey}
				loadOptions={_.debounce(this.getOptions, 200)}
				onInputChange = {this.onInputChange}
				name={this.props.name}
				value={this.state.value}
				filterOptions={false}
				optionRenderer={this.optionRenderer}
				valueRenderer={this.valueRenderer}
				inputRenderer={(args) => this.inputRenderer(args)}
				onChange={this.onChange}
				autoload={this.state.autoload}
				className={`${this.props.className} ${this.props.disabled ? 'ndtclass' : ''}`}
				placeholder={this.props.placeholder}
				pageSize={10}
				required={this.props.required}
				clearable={this.props.required ? false : true}
				disabled={this.props.disabled}
				cache={false}
				autoFocus={this.props.autoFocus} />
		);
	}

	render() {
		return this.renderSelect();
	}
});

export class InputRenderer extends Component {
	constructor(props) {
		super(props);

		this.state = {
			value: this.props.custvalueObj.value ? this.props.custvalueObj.value[this.props.custvalueObj.displayLabelKey] : ''
		}

		this.focus = this.focus.bind(this);
		this.blur = this.blur.bind(this);
		this.onFocus = this.onFocus.bind(this);
		this.onBlur = this.onBlur.bind(this);
	}

	componentWillReceiveProps(nextprops) {
		this.setState({
			value: nextprops.custvalueObj.value ? nextprops.custvalueObj.value[nextprops.custvalueObj.displayLabelKey] : ''
		});
	}

	focus(arg1, arg2) {
		this.refs.input.focus(arg1, arg2);
	}

	blur(arg1, arg2) {
		this.refs.input.blur(arg1, arg2);
	}

	onFocus(evt) {
		let value = this.props.custvalueObj.value ? this.props.custvalueObj.value[this.props.custvalueObj.displayLabelKey] : ''
		this.setState({
			value: value
		});
		this.props.onFocus();
		if(value != '') {
			evt.target.value = this.props.custvalueObj.isCreatable ? value : '__';
			this.props.onChange(evt);
		}
	}

	onBlur() {
		this.setState({
			value: ''
		});
		this.props.onBlur();
	}

	render() {
		let allProps = {
			...this.props
		};
		delete allProps.custvalueObj;
		return (
			<div className="Select-input">
				<input ref="input" {...allProps} value={this.props.value && this.props.value != '__' ? this.props.value : (this.props.custvalueObj.disabled ? this.props.value : this.state.value)} onFocus={this.onFocus} onBlur={this.onBlur}  autoComplete="off"></input>
			</div>
		);
	}
}


export class SessionExpireModal extends Component {
	constructor(props) {
		super(props);
		this.buttonOnClick = this.buttonOnClick.bind(this);
	}

	buttonOnClick() {
		//window.location.reload();
		window.location='/login';
	}

	render() {
		return (
			<div>
				<div className="react-modal-body text-center">
					<img src="/images/session-expired.png" style={{background: "transparent"}} />
					<div className="margintop-30 marginbottom-20"><b className="font-20">You have been logged out.</b></div>
					<div>Please login to use dashboard</div>
				</div>
				<div className="react-modal-footer bordertop-0 text-center">
					<button type="button" className="btn btn-sm btn-width gs-btn-success" onClick={this.buttonOnClick}>Login</button>
				</div>
			</div>
		);
	}
}

export class ConnectionErrorModal extends Component {
	constructor(props) {
		super(props);

		this.buttonOnClick = this.buttonOnClick.bind(this);
	}

	buttonOnClick() {
		this.props.callback();
		this.props.closeModal();
	}

	render() {
		return (
			<div>
				<div className="react-modal-body text-center">
					<img src="/images/no-internet.png" style={{background: "transparent"}} />
					<div className="margintop-30 marginbottom-20"><b className="font-20">Internet connectivity problem!</b></div>
					<div>Unable to connect with the server. Please check your internet and try again.</div>
				</div>
				<div className="react-modal-footer bordertop-0 text-center">
					<button type="button" className="btn btn-sm btn-width gs-btn-success" onClick={this.buttonOnClick}>Ok</button>
				</div>
			</div>
		);
	}
}

export class TimeOutModal extends Component {
	constructor(props) {
		super(props);

		this.buttonOnClick = this.buttonOnClick.bind(this);
	}

	buttonOnClick() {
		this.props.closeModal();
	}

	render() {
		return (
			<div>
				<div className="react-modal-body text-center">
					<img src="/images/timeout.png" style={{background: "transparent"}} />
					<div className="margintop-30 marginbottom-20"><b className="font-20">Taking longer than usual!</b></div>
					<div className="marginbottom-20">Sorry, it is taking longer than expected. Please try the following:</div>
					<ol>
						<li>Check your connectivity and try again.</li>
						<li>Reload the page once and try again.</li>
						<li>If you still face the issue, please reach out to support.</li>
					</ol>
				</div>
				<div className="react-modal-footer bordertop-0 text-center">
					<button type="button" className="btn btn-sm btn-width gs-btn-success" onClick={this.buttonOnClick}>Ok</button>
				</div>
			</div>
		);
	}
}

export const AutoSuggest = connect((state) =>{
	return {app: state.app}
}) (class extends Component {
	constructor(props) {
		super(props);

		this.state = {
			value : this.props.value ? {name : this.props.value} : null
		};

		this.getOptions = this.getOptions.bind(this);
		this.onChange = this.onChange.bind(this);
		this.inputRenderer = this.inputRenderer.bind(this);
		this.valueRenderer = this.valueRenderer.bind(this);
	}

	componentWillReceiveProps(nextprops) {
		this.setState ({
			value : nextprops.value ? {name : nextprops.value} : null
		});
	}

	getOptions(input, callback) {
		if(input == '' || input == undefined || input == null)
			return callback(null, {
				options: []
			});

		let filterField = `${this.props.filter != "" && this.props.filter != undefined && this.props.filter != null ? this.props.filter : ''}`;
		let filterString = `${filterField}`;

		filterString = encodeURIComponent(filterString);

		let queryString = `/api/autosuggestquery?field=${this.props.field}&resource=${this.props.resource}&value=${input}&filtercondition=${filterString}`;
		axios.get(queryString).then((response) => {
			if(response.data.message == 'success') {
				callback(null, {
					options: response.data.main
				});
			} else {
				callback(null, {
					options: []
				});
			}
		});
	}

	onChange(value) {
		this.props.onChange(value ? value.name : null);
	}

	valueRenderer() {
		if(this.props.disabled)
			return this.state.value['name'];
		return '';
	}

	inputRenderer(args) {
		return <InputRenderer {...args} custvalueObj={{value: this.state.value, isCreatable: true, displayLabelKey: 'name', disabled: this.props.disabled}} />
	}

	shouldKeyDownEventCreateNewOption(event) {
		if (event.keyCode === 188) { //for comma
			return null;
		}
		if (event.keyCode === 13 || event.keyCode === 9) {//for tab and enter
			return { keyCode: event.keyCode };
		}
	}

	render() {
		return (
			<ReactSelectAsync
				multi={false}
				autoBlur={true}
				loadOptions={_.debounce(this.getOptions, 200)}
				valueKey="name"
				labelKey="name"
				value={this.state.value}
				name={this.props.name}
				onChange={this.onChange}
				valueRenderer={this.valueRenderer}
				inputRenderer={(args) => this.inputRenderer(args)}
				shouldKeyDownEventCreateNewOption={this.shouldKeyDownEventCreateNewOption}
				className={`${this.props.className} ${this.props.disabled ? 'ndtclass' : ''}`}
				placeholder={this.props.placeholder}
				required={this.props.required}
				disabled={this.props.disabled}
				cache={false}
			/>
		);
	}
});


// WEBPACK FOOTER //
// ./public/react/components/utils/utilcomponents.js